import React, { createContext, useContext, useEffect, useState } from 'react';
import { adminApi, setAdminToken, getAdminToken } from '../lib/adminApi';

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null); // null = checking, false = signed out, object = signed in

  const checkAuth = async () => {
    if (!getAdminToken()) {
      setAdmin(false);
      return;
    }
    try {
      const { data } = await adminApi.get('/auth/me');
      setAdmin(data);
    } catch {
      setAdminToken(null);
      setAdmin(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const login = async (email, password) => {
    const { data } = await adminApi.post('/auth/login', { email, password });
    setAdminToken(data.token);
    setAdmin({ email: data.email, role: data.role });
    return data;
  };

  const logout = async () => {
    setAdminToken(null);
    setAdmin(false);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, login, logout, checkAuth }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);
